import { render, staticRenderFns } from "./PostcardPatternEditor.vue?vue&type=template&id=72e8987d&scoped=true&"
import script from "./PostcardPatternEditor.vue?vue&type=script&lang=js&"
export * from "./PostcardPatternEditor.vue?vue&type=script&lang=js&"
import style0 from "./PostcardPatternEditor.vue?vue&type=style&index=0&id=72e8987d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e8987d",
  null
  
)

export default component.exports